"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addStep = addStep;
const dist_1 = require("../../fs/dist");
async function addStep(input, deps) {
    if (!input.step || !input.step.description || !input.step.description.trim()) {
        throw new Error('addStep requires step.description.');
    }
    const weaveId = await (0, dist_1.resolveWeaveIdForPlan)(deps.loomRoot, input.planUlid);
    const weave = await deps.loadWeave(deps.loomRoot, weaveId);
    const plan = weave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    if (!plan) {
        throw new Error(`Plan '${input.planUlid}' not found in weave '${weaveId}'`);
    }
    const step = {
        description: input.step.description,
        ...(input.step.title !== undefined ? { title: input.step.title } : {}),
        ...(input.step.files !== undefined ? { files_touched: input.step.files } : {}),
        ...(input.step.blockedBy !== undefined ? { blockedBy: input.step.blockedBy } : {}),
        ...(input.step.satisfies !== undefined ? { satisfies: input.step.satisfies } : {}),
        ...(input.step.detail !== undefined ? { detail: input.step.detail } : {}),
    };
    await deps.runEvent(weaveId, {
        type: 'ADD_STEP',
        planId: input.planUlid,
        step,
        ...(input.position !== undefined ? { position: input.position } : {}),
    });
    const updatedWeave = await deps.loadWeave(deps.loomRoot, weaveId);
    const updatedPlan = updatedWeave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    return { plan: updatedPlan };
}
